import React from 'react';
// import PropTypes from 'prop-types';

import {
    ExpandableTableWidget,
} from '../../widgets';

import './SVODReport.scss';

const SVODReport = (props) => {
    const {
        tableData: {
            data: {
                headers = [],
                rows = [],
            } = {},
        } = {},
        error = null,
    } = props;

    // console.log(headers, rows);
    // console.log(headers, rows);
    return (
        <div className="dashboard">
            <a href="/svod_report.csv" download id="dwnld-btn">Download full report</a>
            <ExpandableTableWidget input={{ error, data: { headers, rows } }} />
        </div>
    );
};

SVODReport.defaultProps = null;

export default SVODReport;
